// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__2h7e3","validationTips":"StatementDescriptor_validationTips__3pFFu"};